import axios, { AxiosResponse, RawAxiosRequestHeaders } from 'axios';

export default class GenericApiAdapter {
  private readonly headers: object;
  private readonly apiBaseUrl: string;
  public initialQueryParams: object = {};

  public constructor(apiBaseUrl: string, initialQueryParams: object = {}, headers: object = {}) {
    this.apiBaseUrl = apiBaseUrl;
    this.headers = headers;
    this.initialQueryParams = initialQueryParams;
  }

  private getHeaders(headers: object = {}): RawAxiosRequestHeaders {
    return {
      Accept: 'application/json',
      ...this.headers,
      ...headers,
    };
  }

  public async get<T>(url: string, headers: object = {}, queryParams?: object): Promise<T> {
    const result: AxiosResponse<T> = await axios.get(this.apiBaseUrl + encodeURI(url), {
      headers: this.getHeaders(headers),
      params: queryParams,
    });

    return result.data;
  }

  public async post<T>(url: string, body: any, headers: object = {}): Promise<T> {
    const result: AxiosResponse<T> = await axios.post(this.apiBaseUrl + encodeURI(url), body, {
      headers: this.getHeaders(headers),
    });

    return result.data;
  }
}
